import { combineReducers } from 'redux'

import AuthReducer from './auth.reducer'
import AppReducer from './app.reducer'
import AccountReducer from './account.reducer'
import UserReducer from './user.reducer'
import OfferReducer from './offer.reducer'
import BillerReducer from './offer.reducer'
import ErrorReducer from './error.reducer'
import storage from 'redux-persist/lib/storage'
import { persistReducer } from 'redux-persist'

const appPersistConfig = {
  key: 'auth',
  storage,
  whitelist: ['message'],
}

const appReducer = combineReducers({
  auth: persistReducer(appPersistConfig, AuthReducer),
  app: AppReducer,
  account: AccountReducer,
  user: UserReducer,
  offer: OfferReducer,
  biller: BillerReducer,
  errors: ErrorReducer
})

const rootReducer = (state, action) => {
  if (action.type === 'USER_LOGOUT') {
    state = undefined
  }
  return appReducer(state, action)
}

export default rootReducer
